import { IonButtonWrapper } from 'components/common/button/Button.styled';
import styled from 'styled-components';
import { prem } from 'styles/helpers/spacing';
import { installStepsStyles } from 'components/install-app-tuto/InstallSteps.styled';

const TutoSmartphoneWrapper = styled.div`
  padding-bottom: ${prem(20)};

  ${installStepsStyles}

  ${IonButtonWrapper} {
    width: 100%;
    max-width: ${prem(300)};
  }
`;

export { TutoSmartphoneWrapper };
